import { createTheme } from "@mui/material/styles";

const CustomTheme = createTheme({
  typography: {
    fontFamily: '"Montserrat","Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export default CustomTheme;
